import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthenticateService } from "../../shared/services/authenticate.service";
import { wfsService } from "src/app/shared/services/wfs.service";
import { UUID } from "angular2-uuid";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { HttpClient } from "@angular/common/http";
import { CognitoService } from "src/app/shared/services/cognito.service";
@Component({
  selector: "app-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.sass"],
})
export class ListComponent implements OnInit {
  listsArray = [];
  lists = ["Constant", "Normal rest", "Smart rest"];
  showList: boolean = true;
  type: string = "save";
  globalImgUrl: any;
  groupName: any;
  loading: boolean;
  // listObj = { listName: "", listType: "", constantValues: "", keyValue: "" };
  listObj: any = {};
  listForm: FormGroup;
  selectedUuid: any;
  editIndex: any;
  constantValues = "";
  restArray: any;
  showKeyValueInput: boolean = false;
  showResponse: boolean = false;
  keyValueTableData = [];
  constantsArray = [];
  showTestBtn: boolean = true;
  result: Object;
  validUrl: boolean;
  inValidUrl: boolean;
  showConstants: boolean;
  enableSave: boolean = false;
  existingListArray: any = [];
  enableDependentDropDown: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthenticateService,
    private wfsService: wfsService,
    private http: HttpClient,
    private cognitoService: CognitoService
  ) { }

  async ngOnInit() {
    if (!this.globalImgUrl) {
      this.globalImgUrl = this.authService.s3url();
    }
    await this.cognitoService.getCurrentUserToken().then((res: any) => {
      this.groupName = res.attributes.family_name;
      this.getAllLists();
    });
    this.listForm = this.formBuilder.group({
      listName: ["", Validators.required],
      listType: ["", Validators.required],
      dependentOn: [''],
    });
  }

  handleInput(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }
  editData(index) {
    this.selectedUuid = "";
    this.validUrl = false;
    this.inValidUrl = false;
    this.showResponse = false;
    this.showList = false;
    this.editIndex = index;
    this.enableDependentDropDown = this.listsArray[index].url.endsWith('<key>') ? true : false;
    if (this.enableDependentDropDown) {
      this.listForm = this.formBuilder.group({
        listName: ['', Validators.required],
        listType: ['', Validators.required],
        dependentOn: ['', Validators.required],
      });
      console.log(this.listObj['dependentOn'], this.listForm);
      this.listObj['dependentId'] = (this.listsArray[index].dependentOn && this.listsArray[index].dependentOn.uuid) ? this.listsArray[index].dependentOn.uuid : '';
      this.listObj.dependentOn = this.listsArray[index].dependentOn ? this.listsArray[index].dependentOn : {};
    }
    this.listObj["listName"] = this.listsArray[index].name;
    this.listObj["listType"] = this.listsArray[index].type;
    this.constantsArray = this.listsArray[index].constantValues;
    this.listObj["constantValues"] = this.listsArray[index].values
      ? this.listsArray[index].values
      : "";
    this.listObj["keyValue"] = this.listsArray[index].url
      ? this.listsArray[index].url
      : "";
    this.listObj["parameter"] = this.listsArray[index].parameter
      ? this.listsArray[index].parameter
      : "";
    this.selectedUuid = this.listsArray[index].uuid;
    this.showConstants = this.listObj["listType"] == "constant" ? true : false;
    this.type = "update";
  }
  getAllLists() {
    this.loading = true;
    this.listsArray = [];
    let obj = {
      // group: this.groupName,
    };
    this.existingListArray = [];
    this.wfsService.getAllLists(obj).then((data: any) => {
      if (data.length > 0) {
        this.listsArray = data;
        this.existingListArray = data.map(element => ({
          name: element.name,
          uuid: element.uuid
        }));
        console.log("existingListArray value", data, this.existingListArray);
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
  }
  testKeyValue(url) {
    this.enableDependentDropDown = url.endsWith('<key>') ? true : false;
    if (this.enableDependentDropDown) {
      this.listForm = this.formBuilder.group({
        listName: [this.listObj.listName, Validators.required],
        listType: [this.listObj.listType, Validators.required],
        dependentOn: ['', Validators.required],
      });
    }
    this.getData(url);
  }
  testParameterised(url) {
    if (url.endsWith("?=")) {
      this.validUrl = true;
      this.inValidUrl = false;
      this.showTestBtn = false;
    } else {
      this.validUrl = false;
      this.inValidUrl = true;
    }
  }
  changedListType(e) {
    if (e == "keyValueRest") {
      this.showKeyValueInput = true;
      this.showConstants = false;
    } else {
      this.showResponse = false;
      this.showTestBtn = false;
      this.showConstants = false;
    }
    this.validUrl = false;
    this.inValidUrl = false;
    this.enableDependentDropDown = false;
    this.listObj.keyValue = "";
  }
  addConstants() {
    this.constantsArray = [];
    this.constantsArray.push(this.listObj.constantValues);
    this.listObj.constantValues = "";
    this.showConstants = true;
  }
  deleteConstant(index) {
    this.constantsArray.splice(index, 1);
  }
  changeOnDependent(listId: any) {
    console.log("list value", listId);
    this.listObj.dependentOn = this.existingListArray.filter(item => item.uuid === listId)[0];
  }
  addList() {
    this.showList = false;
    this.listObj = {
      listName: "",
      listType: "",
      constantValues: "",
      keyValue: "",
    };
    this.type = "save";
    this.inValidUrl = false;
    this.validUrl = false;
    this.showResponse = false;
    this.showConstants = false;
    this.enableDependentDropDown = false;
    this.listForm.reset();
  }
  saveList() {
    this.loading = true;
    let obj = {
      uuid: UUID.UUID(),
      name: this.listObj["listName"],
      type: this.listObj["listType"],
      url: this.listObj["keyValue"],
      dependentOn: this.listObj.dependentOn,
      group: this.groupName,
    };
    obj["values"] =
      this.constantsArray && this.constantsArray.length > 0
        ? this.constantsArray
        : "";
    console.log(obj)
    this.wfsService.saveList(obj).then((data: any) => {
      if (data) {
        Swal({ title: "Saved successfully" });
        this.getAllLists();
        this.constantsArray = [];
        this.showList = true;
        this.enableDependentDropDown = false;
      } else {
        this.loading = false;
        Swal.fire(
          "Error",
          "Data not Submitted (please contact admin)",
          "error"
        );
        this.constantsArray = [];
        this.showList = true;
        this.enableDependentDropDown = false;
      }
    });
  }
  getData(url) {
    this.http.get(url).subscribe((res: any) => {
      if (res) {
        console.log("@@Response in getData:", res);
        this.result = res;
        if (this.result && Array.isArray(this.result)) {
          this.enableSave = true;
          this.validUrl = true;
          this.inValidUrl = false;
          this.showTestBtn = false;
          this.restArray = this.result;
          this.showResponse = true;
        } else if (this.result["message"] == "Invalid") {
          this.inValidUrl = true;
          this.validUrl = false;
          this.showResponse = false;
        }
      } else {
        this.inValidUrl = true;
        this.validUrl = false;
        this.showResponse = false;
      }
    });
  }
  back() {
    this.showList = true;
    this.type = "save";
    this.listForm.reset();
    this.enableDependentDropDown = false;
    this.getAllLists();
  }
  updateList() {
    this.loading = true;
    let obj = {
      name: this.listObj["listName"],
      type: this.listObj["listType"],
      url: this.listObj["keyValue"],
      dependentOn: this.listObj.dependentOn
    };
    obj["values"] =
      this.constantsArray && this.constantsArray.length > 0
        ? this.constantsArray
        : "";
    delete obj["_id"];
    this.wfsService.updateList(obj, this.selectedUuid).then((data: any) => {
      console.log("@@result in update list:", data);
      if (data.result == "SUCCESS") {
        Swal({ title: "Updated successfully" });
        this.showList = true;
        this.listForm.reset();
        this.enableDependentDropDown = false;
        this.getAllLists();
      } else {
        this.loading = false;
        Swal.fire(
          "Error",
          "Data not Submitted (please contact admin)",
          "error"
        );
      }
    });
  }
}
